// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blogs_blog-card-container__pLQsc > .Blogs_blog-card__uZ4Al:not(:nth-child(3n)) {
    margin-right:3vw;
}

.Blogs_blog-card-container__pLQsc > .Blogs_blog-card__uZ4Al:nth-child(3n) {
    margin-right:0;
}

@media(max-width: 1024px){
    .Blogs_blog-card__uZ4Al{
        margin-right: 0;
    }
}

.Blogs_blog-info__Rxc4V {
    /* background: rgba(105, 201, 239, 0.2) */
}

.Blogs_blog-container-border__bqVT0{
    border: 2px solid rgba(105, 201, 239, 0.4);
    padding: 15px;
    border-radius: 20px;
}

.Blogs_blog-container__gwr4Z {
    overflow-x: scroll;
    overflow-y: hidden;
    /* border: 2px solid blue; */
    /* border-left: 0px; */
    /* border-right: 0px; */
    /* width: calc(100% + 4px); */
    /* height: calc(100% + 4px); */
    /* border: 2px solid transparent; */
    /* border-radius: inherit; */
    /* animation: spin 2s linear infinite; */
    /* box-shadow: 0vw 6vw 20px rgba(230, 84, 57, 0.2); */
    /* box-shadow: 0px 0px 100px rgba(105, 201, 239, 0.8); */
    /* background-color: rgba(105, 201, 239, 0.4) */
}

.Blogs_blog-single__LzLzB {
    border: 1px solid rgba(105, 201, 239, 0.4);
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}

.Blogs_blog-single__LzLzB img {
    -webkit-user-select: none;
            user-select: none;
}

.Blogs_blog-container__gwr4Z:active {
    cursor: grabbing;
}

.Blogs_blog-container__gwr4Z::-webkit-scrollbar {
    display: none;
}

.Blogs_blog-sub-heading__q24xB::-webkit-scrollbar {
    display: none;
}

@keyframes Blogs_spin__FdSCm {
    0% {
        border-top-color: rgba(105, 201, 239, 0.4);
    }

    25% {
        border-right-color: rgba(105, 201, 239, 0.4);
    }

    50% {
        border-bottom-color: rgba(105, 201, 239, 0.4);
    }

    75% {
        border-left-color: rgba(105, 201, 239, 0.4);
    }

    100% {
        border-top-color: rgba(105, 201, 239, 0.4);
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Blogs/Blogs.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,mCAAmC;IACnC,4BAA4B;IAC5B,wCAAwC;IACxC,qDAAqD;IACrD,wDAAwD;IACxD,+CAA+C;AACnD;;AAEA;IACI,0CAA0C;IAC1C,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,0CAA0C;IAC9C;AACJ","sourcesContent":[".blog-card-container > .blog-card:not(:nth-child(3n)) {\n    margin-right:3vw;\n}\n\n.blog-card-container > .blog-card:nth-child(3n) {\n    margin-right:0;\n}\n\n@media(max-width: 1024px){\n    .blog-card{\n        margin-right: 0;\n    }\n}\n\n.blog-info {\n    /* background: rgba(105, 201, 239, 0.2) */\n}\n\n.blog-container-border{\n    border: 2px solid rgba(105, 201, 239, 0.4);\n    padding: 15px;\n    border-radius: 20px;\n}\n\n.blog-container {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    /* border: 2px solid blue; */\n    /* border-left: 0px; */\n    /* border-right: 0px; */\n    /* width: calc(100% + 4px); */\n    /* height: calc(100% + 4px); */\n    /* border: 2px solid transparent; */\n    /* border-radius: inherit; */\n    /* animation: spin 2s linear infinite; */\n    /* box-shadow: 0vw 6vw 20px rgba(230, 84, 57, 0.2); */\n    /* box-shadow: 0px 0px 100px rgba(105, 201, 239, 0.8); */\n    /* background-color: rgba(105, 201, 239, 0.4) */\n}\n\n.blog-single {\n    border: 1px solid rgba(105, 201, 239, 0.4);\n    user-select: none;\n    cursor: pointer;\n}\n\n.blog-single img {\n    user-select: none;\n}\n\n.blog-container:active {\n    cursor: grabbing;\n}\n\n.blog-container::-webkit-scrollbar {\n    display: none;\n}\n\n.blog-sub-heading::-webkit-scrollbar {\n    display: none;\n}\n\n@keyframes spin {\n    0% {\n        border-top-color: rgba(105, 201, 239, 0.4);\n    }\n\n    25% {\n        border-right-color: rgba(105, 201, 239, 0.4);\n    }\n\n    50% {\n        border-bottom-color: rgba(105, 201, 239, 0.4);\n    }\n\n    75% {\n        border-left-color: rgba(105, 201, 239, 0.4);\n    }\n\n    100% {\n        border-top-color: rgba(105, 201, 239, 0.4);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blog-card-container": `Blogs_blog-card-container__pLQsc`,
	"blog-card": `Blogs_blog-card__uZ4Al`,
	"blog-info": `Blogs_blog-info__Rxc4V`,
	"blog-container-border": `Blogs_blog-container-border__bqVT0`,
	"blog-container": `Blogs_blog-container__gwr4Z`,
	"blog-single": `Blogs_blog-single__LzLzB`,
	"blog-sub-heading": `Blogs_blog-sub-heading__q24xB`,
	"spin": `Blogs_spin__FdSCm`
};
export default ___CSS_LOADER_EXPORT___;
